import { render, staticRenderFns } from "./EditBookingHoursPolicyLimit.vue?vue&type=template&id=02567772&scoped=true&"
import script from "./EditBookingHoursPolicyLimit.vue?vue&type=script&lang=js&"
export * from "./EditBookingHoursPolicyLimit.vue?vue&type=script&lang=js&"
import style0 from "./EditBookingHoursPolicyLimit.vue?vue&type=style&index=0&id=02567772&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02567772",
  null
  
)

export default component.exports